import groq from 'groq';

export const BAR_CHART = groq`
  yAxisLabel,
  xAxisLabel,
  scale {
    suffix,
    prefix,
  },
  controlLabel,
  treatmentLabel,
  groups[] {
    label,
    controlValue,
    controlErrorHigh,
    controlErrorLow,
    treatmentValue,
    treatmentErrorHigh,
    treatmentErrorLow,
    comparisonLabel,
    comparisonSignificance,
  }
`;
